import React from "react";
import { connect } from "react-redux";

import { goTo } from "../tools";
import SeguridadForm from "./seguridad.frm";
import PasswordForm from "./password.frm";
import ModalMessage from "../registro/modalMessage";
import { actualizarDatos, actualizarPassword } from "./servicios.act";

const mapState = (state) => {
	return {
		uid: state.recuperar.uid,
		estatus: state.recuperar.estatus,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		showLoad: () => {
			dispatch({ "type": "LOADER_SHOW" });
		},
		alerta: (sTitulo, sMensaje, fnCerrar) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": sTitulo, "mensaje": sMensaje, "accion": fnCerrar });
		},
		actualizarDatos(datos, tags) {
			dispatch(actualizarDatos(datos, tags));
		},
		actualizarPassword(uid, pass, disp) {
			dispatch(actualizarPassword(uid, pass, disp));
		}
	};
};

class Seguridad extends React.Component {

	close = () => {
		goTo("login");
	}

	render() {
		return (
			<div>
				{this.props.tipo == "nm" &&
					<PasswordForm />
				}
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Seguridad);


// WEBPACK FOOTER //
// ./src/gnp-recuperar-contrasenia/seguridad.cmpt.js